import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2159cd8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-viewer-mobile" }
const _hoisted_2 = { class: "level-center is-mobile" }
const _hoisted_3 = {
  key: 0,
  class: "image-viewer-mobile-walkthrough has-background-translucent has-text-modest level-center is-mobile"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "フリックで次へ", -1))
const _hoisted_5 = { class: "image-viewer-mobile-modal-windows" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "設定", -1))
const _hoisted_7 = { class: "image-viewer-mobile-abstract" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageViewerHeader = _resolveComponent("ImageViewerHeader")!
  const _component_TheImageViewer = _resolveComponent("TheImageViewer")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_ImageViewerFooter = _resolveComponent("ImageViewerFooter")!
  const _component_HelpImageViewerMobile = _resolveComponent("HelpImageViewerMobile")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!
  const _component_ImageViewerSettings = _resolveComponent("ImageViewerSettings")!
  const _component_ModalSheet = _resolveComponent("ModalSheet")!
  const _component_AddonView = _resolveComponent("AddonView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (_ctx.state.showNav)
          ? (_openBlock(), _createBlock(_component_ImageViewerHeader, {
              key: 0,
              modelValue: _ctx.state.modal,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.modal) = $event)),
              abstract: _ctx.abstract,
              item: _ctx.item,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            }, null, 8, ["modelValue", "abstract", "item"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "image-viewer-mobile-body level-center is-mobile",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.showNav = !_ctx.state.showNav)),
      onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.state.showNav = !_ctx.state.showNav), ["prevent"]), ["space","enter"]))
    }, [
      _createElementVNode("figure", _hoisted_2, [
        _createVNode(_component_TheImageViewer, {
          key: _ctx.item.pid + _ctx.bundleIndex,
          item: _ctx.item
        }, null, 8, ["item"])
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.state.showWalkthrough)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_DssIcon, { icon: "touchinput-flick-right" }),
                _hoisted_4
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 32),
    _createVNode(_Transition, { name: "slide-up" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_ImageViewerFooter, {
          item: _ctx.item,
          onTouchstart: _ctx.stopTimeout,
          onTouchend: _ctx.renewTimeout
        }, null, 8, ["item", "onTouchstart", "onTouchend"]), [
          [_vShow, _ctx.state.showNav]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_TransitionGroup, { name: "modal" }, {
        default: _withCtx(() => [
          (_ctx.state.modal === 'help')
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 0,
                onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.modal = '')),
                heading: _ctx.$t('header.help')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_HelpImageViewerMobile, { lang: _ctx.lang }, null, 8, ["lang"])
                ]),
                _: 1
              }, 8, ["heading"]))
            : _createCommentVNode("", true),
          (_ctx.state.modal === 'settings')
            ? (_openBlock(), _createBlock(_component_ModalSheet, {
                key: 1,
                onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.modal = '')),
                class: "image-viewer-mobile-settings has-background-contents"
              }, {
                header: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_ImageViewerSettings, { item: _ctx.item }, null, 8, ["item"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.state.modal === 'abstract')
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 2,
                onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.modal = '')),
                heading: _ctx.$t('label.abstract')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.abstract), 1)
                ]),
                _: 1
              }, 8, ["heading"]))
            : _createCommentVNode("", true),
          (_ctx.state.modal === 'addonView')
            ? (_openBlock(), _createBlock(_component_ModalSheet, {
                key: 3,
                onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.modal = '')),
                class: "has-background-contents"
              }, {
                header: _withCtx(() => [
                  _hoisted_8
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_AddonView, {
                    item: _ctx.item,
                    "tab-view-flag": _ctx.tabViewFlag,
                    "viewer-type": "TheImageViewer",
                    id: "image-viewer-mobile-addon-view"
                  }, null, 8, ["item", "tab-view-flag"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}